import { render, staticRenderFns } from "./WithdrawalComplete.vue?vue&type=template&id=6206b926&scoped=true"
import script from "./WithdrawalComplete.vue?vue&type=script&lang=js"
export * from "./WithdrawalComplete.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalComplete.vue?vue&type=style&index=0&id=6206b926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6206b926",
  null
  
)

export default component.exports